<!--
@负责人: xiehan
@创建时间: 2017-7-23
@版本:v1.0.0
@描述:数据统计块
@使用方法:
<template>
        <describe-block :list="list"></describe-block>
</template>
<script>
    export default {
        components: {
            describeBlock: require('./components/describeBlock.vue')
        },
        data() {
            return {
                list: [
                    {num: '3', title: '事故数'},
                    {num: '3', title: '事故数'},
                    {num: '3', title: '事故数'},
                    {num: '3', title: '事故数'}
                ]
            }
        }
    }
</script>
@参数说明:
// 内容描述
-->

<template>
    <div>
        <ul class="describe-block-wrap">
            <li class="describe-each-block" v-for="(item, index) in list" :class="{
                'background0': index == 0,
                'background1': index == 1,
                'background2': index == 2,
                'background3': index == 3}"
                :key="index">
                <img class="describe-bg-img" :src="toNumber(item.num) ? alert_bg : time_bg">
                <div class="describe-block-head">
                    <img class="describe-block-icon" :src="toNumber(item.num) ? alert : time">
                    <span class="describe-block-title" v-text="item.title"></span>
                </div>
                <div class="describe-block-num">
                    <div v-if="typeof item.num == 'number'">
                        <span v-text="item.num"></span>
                    </div>
                    <div v-if="typeof item.num != 'number'">
                        <span :class="{isString : !toNumber(newItem)}" v-for="(newItem,newIndex) in item.num" :key="newIndex" v-text="newItem"></span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
      data () {
        return {
          alert: require('../../../assets/image/systemDiagram/alert.png'),
          time: require('../../../assets/image/systemDiagram/time.png'),
          alert_bg: require('../../../assets/image/base/alert.png'),
          time_bg: require('../../../assets/image/base/time.png')
        }
      },
      methods: {
        toNumber (value) {
          let newValue = Number(value)
          if (isNaN(newValue)) {
            return false
          } else {
            return true
          }
        }
      },
      props: {
        list: {
          type: Array,
          default: function () {
            return []
          }
        }
      },
      watch: {
        list () {
          this.list.forEach(function (item) {
            let oldNum = item.num
            if (typeof oldNum !== 'number') {
              item.num = []
              for (let i = 0; i < oldNum.length; i++) {
                item.num.push(oldNum[i])
              }
            }
          })
        }
      }
    }
</script>

<style scoped>
    .describe-block-wrap {
        display: flex;
        display: -webkit-flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        list-style: none;
    }
    .describe-each-block {
        position: relative;
        width: 0px;
        margin-right: 20px;
        flex-grow: 1;
        height: 120px;
        border-radius: 2px;
    }
    .describe-each-block:last-child {
        margin-right: 0;
    }
    .background0 {
        background: #F27373;
    }
    .background1 {
        background: #EE9954;
    }
    .background2 {
        background: #40C3B3;
    }
    .background3 {
        background: #52B947;
    }
    .describe-block-head {
        margin-top: 6px;
        margin-bottom: 6px;
        padding-left: 6px;
    }
    .describe-block-head * {
        vertical-align: middle;
    }
    .describe-block-icon {
        width: 16px;
        height: 16px;
    }
    .describe-block-title {
        display: inline-block;
        font-size: 16px;
        color: white;
    }
    .describe-block-num {
        font-family: fantasy;
        color: white;
        font-size: 50px;
        text-align: center;
    }
    .describe-block-num span {
        display: inline-block;
    }
    .describe-block-num .isString {
        font-size: 30px;
    }
    .describe-bg-img {
        position: absolute;
        width: 90px;
        height: 80px;
        bottom: 0;
        left: 10px;
    }
</style>